import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import ListItemIcon from '@mui/material/ListItemIcon';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};



export default function MultipleSelectCheckmarks({ items,
    labelId,
    labelText,
    selectId,
    onChange,
    defaultValues
    }) {

    const [selectedItems, setSelectedItems] = React.useState(defaultValues ?? []);

    const isAllSelected = items.length > 0 && selectedItems.length === items.length;

    const handleChange = (event) => {

        let selectedvalues = [];

        if (
            event.target.value.includes("all") &&
            selectedItems.length !== items.length
        ) {

            selectedvalues = items.map((item) => item.value);  
            
        } else if (event.target.value.includes("all")) {
            selectedvalues = []
        } else {
            selectedvalues = event.target.value;
        }

        setSelectedItems(selectedvalues);
        if (onChange) {
            onChange(event, selectedvalues);
        }
    };

    const displaySelected = (selected) => {

        if (selected) {
            if (selected.length == 1) {
                let s = items.filter(s => {
                    return s.value == selected[0];
               })
                return s[0].text;
            }
            else {
                return `${selected.length} of ${items.length}`;
            }
        }
        else {
            return '';
        }
    };

    const SelectFieldStyle = {
        fontSize: "0.75rem",
        padding: "8px",
        paddingBottom: "13px"
    };

    return (
        <div>
            <FormControl sx={{ m: 1, width: "100%" }} >
                <InputLabel id={ labelId } >{ labelText }</InputLabel>
                <Select
                    labelId={labelId}
                    id={selectId}
                    multiple
                    value={selectedItems}
                    onChange={handleChange}
                    input={<OutlinedInput label={labelText} />}
                    renderValue={(selected) => displaySelected(selected)}
                    MenuProps={MenuProps}
                    SelectDisplayProps={{
                        style: SelectFieldStyle,
                    }}
                >

                    <MenuItem
                        value="all"
                    >
                        <ListItemIcon>
                            <Checkbox
                                checked={isAllSelected}
                            />
                        </ListItemIcon>
                        <ListItemText
                            primary="Select All"
                        />
                    </MenuItem>


                    {items.map((i, index) => (
                        <MenuItem
                            key={index}
                            value={i.value}>
                            <Checkbox
                                key={'ch' + index.toString()}
                                checked={selectedItems.indexOf(i.value) > -1} />
                            <ListItemText
                                key={'lit' + index.toString()}
                                primary={i.text} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}

